const CHANGE_VISIBILITY = 'MENU_CHANGE_VISIBILITY';
const TOGGLE_LOADER = 'LOADER_CHANGE_VISIBILITY';

export const changeVisibility = () => ({
    type: CHANGE_VISIBILITY,
});

export const toggleLoader = () => ({
    type: TOGGLE_LOADER,
});

const defaultState = {
    menuIsOpen: false,
};

export default function (state = defaultState, action) {

    switch (action.type) {
        case CHANGE_VISIBILITY: {
            const stateClone = Object.assign({}, state);
            stateClone.menuIsOpen = !stateClone.menuIsOpen;

            return stateClone;
        }
        case TOGGLE_LOADER: {
            const stateClone = Object.assign({}, state);
            stateClone.loaderIsVisible = !stateClone.loaderIsVisible;

            return stateClone;
        }

        default : {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/MenuReducer.js